import axios from '../../axios'

/*
 * 文章数据接口
 */

// 获取文章列表
export const getArticleList = (data) => {
    return axios({
        url: '/api/base/article/list',
        method: 'post',
        data
    })
}

export const getArticle = (data) => {
    return axios({
        url: '/api/base/getArticle',
        method: 'get',
        data
    })
}

// 新增文章信息
export const saveArticle = (data) => {
    return axios({
        url: '/api/base/article',
        method: 'post',
        data
    })
}

// 编辑文章信息
export const updateArticle = (data) => {
    return axios({
        url: '/api/base/article',
        method: 'put',
        data
    })
}

// 删除文章列表
export const deleteArticle = (data) => {
    return axios({
        url: '/api/base/article',
        method: 'delete',
        data
    })
}

// 获取院校
export const getSchool = (data) => {
    return axios({
        url: '/api/data/wish/search/school',
        method: 'get',
        data
    })
}

// 导入网址
export const importArticleByUrl = (data) => {
    return axios({
        url: '/api/base/article/wx/official/parse',
        method: 'get',
        data
    })
}

// 上传资讯到百度API
export const sumitArticleInfo = (data) => {
    return axios({
        url: '/api/base/article/info/submit',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/info/article.js